module.exports = new __parcel__URL__("404.f6ff16c8.jpeg").toString();